export default __webpack_public_path__ + "static/media/image.c1ac0e64.jpg";